import { useAuthStore } from '@tundr/auth';
import { featureFlagGuard } from '@tundr/feature-flags';
import { appRoutesDictionary } from '@core/router/app-routes.dictionary.ts';
import { CREATE_CARD_ORDER_WIZARD_NAMESPACE } from '../config/create-card-order.constants.ts';
import { CREATE_MEAL_VOUCHER_ORDER_WIZARD_NAMESPACE } from '../config/create-meal-voucher-order.constants.ts';
import { IMPORT_MEAL_VOUCHER_ORDER_WIZARD_NAMESPACE } from '../config/import-meal-voucher-order.constants.ts';
import { MEAL_VOUCHER_UI_HR_MANUAL_ASSIGNMENT_FLAG } from '../config/feature-flags.ts';
import { mealVouchersRoutesDictionary } from './meal-vouchers-routes.dictionary';

export const mealVouchersRoutesConfig = {
  ...mealVouchersRoutesDictionary.mealVouchers.root,
  redirect: {
    name: mealVouchersRoutesDictionary.mealVouchers.cardOrdersList.name,
  },
  beforeEnter: () =>
    useAuthStore().hasMealVoucher || {
      name: appRoutesDictionary.root.app.name,
    },
  children: [
    {
      ...mealVouchersRoutesDictionary.mealVouchers.cardOrdersList,
      component: () =>
        import('../pages/CardOrdersListPage/CardOrdersListPage.vue'),
    },
    {
      ...mealVouchersRoutesDictionary.mealVouchers.createCardOrder,
      meta: {
        wizardNamespace: CREATE_CARD_ORDER_WIZARD_NAMESPACE,
        wizardExitRoute:
          mealVouchersRoutesDictionary.mealVouchers.cardOrdersList.name,
      },
      component: () =>
        import('../pages/CreateCardOrder/CreateCardOrderWizardPage.vue'),
    },
    {
      ...mealVouchersRoutesDictionary.mealVouchers.cardOrderDetail,
      props: true,
      component: () =>
        import(
          '../pages/CardOrdersListPage/CardOrderDetailPage/CardOrderDetailPage.vue'
        ),
    },
    {
      ...mealVouchersRoutesDictionary.mealVouchers.ordersList,
      component: () =>
        import(
          '../pages/MealVoucherOrdersListPage/MealVoucherOrdersListPage.vue'
        ),
    },
    {
      ...mealVouchersRoutesDictionary.mealVouchers.createOrder,
      beforeEnter: featureFlagGuard(MEAL_VOUCHER_UI_HR_MANUAL_ASSIGNMENT_FLAG, {
        redirect: {
          name: mealVouchersRoutesDictionary.mealVouchers.ordersList.name,
        },
      }),
      meta: {
        wizardNamespace: CREATE_MEAL_VOUCHER_ORDER_WIZARD_NAMESPACE,
        wizardExitRoute:
          mealVouchersRoutesDictionary.mealVouchers.ordersList.name,
      },
      component: () =>
        import(
          '../pages/CreateMealVoucherOrder/CreateMealVoucherOrderWizardPage.vue'
        ),
    },
    {
      ...mealVouchersRoutesDictionary.mealVouchers.importOrder,
      meta: {
        wizardNamespace: IMPORT_MEAL_VOUCHER_ORDER_WIZARD_NAMESPACE,
        wizardExitRoute:
          mealVouchersRoutesDictionary.mealVouchers.ordersList.name,
      },
      component: () =>
        import(
          '../pages/ImportMealVoucherOrder/ImportMealVoucherOrderWizardPage.vue'
        ),
    },
    {
      ...mealVouchersRoutesDictionary.mealVouchers.orderDetail,
      props: true,
      component: () =>
        import(
          '../pages/MealVoucherOrdersListPage/MealVoucherOrderDetailPage/MealVoucherOrderDetailPage.vue'
        ),
    },
  ],
};
